export interface NewVoucherFormData {
    type?: string
    id: string
    note?: string
    total: number
    balance: number
    customerId?: number
    issueDate?: string
    invoiceId?: string
    keepOpen: boolean
    paid: boolean
}
export const voucherTypes = [
    null,
    '10E',
    '20E',
    '30E',
    '50E',
    '80E',
    '100E',
    '10P',
    '20P',
    '30P',
    '50P',
    '80P',
    '100P',
    'D10E',
    'D20E',
    'D30E',
    'D50E',
    'D10P',
    'D20P',
    'D30P',
    'D50P',
    'SD10E',
    'SD20E',
    'SD30E',
    'SD50E',
    'SD10P',
    'SD20P',
    'SD30P',
    'SD50P',
    'LDHA-20',
    'LDHA-40',
    'DRD4-20',
    'DRD4-40',
    'DRD4ab-20',
    'DRD4ab-40',
    'škrupiny',
]

export const voucherTypesByMail = [
    {
        id: '20P',
        labels: {
            sk: 'Poukaz na určenie pohlavia na 20 vzoriek, výsledky poštou',
            en: 'Voucher for determining gender for 20 samples, results by mail',
        },
    },
    {
        id: '50P',
        labels: {
            sk: 'Poukaz na určenie pohlavia na 50 vzoriek, výsledky poštou',
            en: 'Voucher for determining gender for 50 samples, results by mail',
        },
    },
    {
        id: '100P',
        labels: {
            sk: 'Poukaz na určenie pohlavia na 100 vzoriek, výsledky poštou',
            en: 'Voucher for determining gender for 100 samples, results by mail',
        },
    },
    {
        id: 'SD10P',
        labels: {
            sk: 'Poukaz na určenie pohlavia + ochorení na 10 vzoriek, výsledky poštou',
            en: 'Voucher for determining gender + diseases for 10 samples, results by mail',
        },
    },
    //do the same for SD20P, SD30P
    {
        id: 'SD20P',
        labels: {
            sk: 'Poukaz na určenie pohlavia + ochorení na 20 vzoriek, výsledky poštou',
            en: 'Voucher for determining gender + diseases for 20 samples, results by mail',
        },
    },
    {
        id: 'SD30P',
        labels: {
            sk: 'Poukaz na určenie pohlavia + ochorení na 30 vzoriek, výsledky poštou',
            en: 'Voucher for determining gender + diseases for 30 samples, results by mail',
        },
    },
    //D10P	Poukaz na detekciu ochorení na 10 vzoriek, výsledky poštou, repeat for D20P, D30P
    {
        id: 'D10P',
        labels: {
            sk: 'Poukaz na detekciu ochorení na 10 vzoriek, výsledky poštou',
            en: 'Voucher for disease detection for 10 samples, results by mail',
        },
    },
    {
        id: 'D20P',
        labels: {
            sk: 'Poukaz na detekciu ochorení na 20 vzoriek, výsledky poštou',
            en: 'Voucher for disease detection for 20 samples, results by mail',
        },
    },
    {
        id: 'D30P',
        labels: {
            sk: 'Poukaz na detekciu ochorení na 30 vzoriek, výsledky poštou',
            en: 'Voucher for disease detection for 30 samples, results by mail',
        },
    },
    // LDHA-20	Poukaz na 20 vzoriek na analýzu LDHA
    {
        id: 'LDHA-20',
        labels: {
            sk: 'Poukaz na 20 vzoriek na analýzu LDHA',
            en: 'Voucher for 20 samples for LDHA analysis',
        },
    },
    //ldha40
    {
        id: 'LDHA-40',
        labels: {
            sk: 'Poukaz na 40 vzoriek na analýzu LDHA',
            en: 'Voucher for 40 samples for LDHA analysis',
        },
    },
    //DRD4-20	Poukaz na 20 vzoriek na analýzu DRD4a, alebo DRD4b
    {
        id: 'DRD4-20',
        labels: {
            sk: 'Poukaz na 20 vzoriek na analýzu DRD4a, alebo DRD4b',
            en: 'Voucher for 20 samples for DRD4a or DRD4b analysis',
        },
    },
    {
        id: 'DRD4-40',
        labels: {
            sk: 'Poukaz na 40 vzoriek na analýzu DRD4a, alebo DRD4b',
            en: 'Voucher for 40 samples for DRD4a or DRD4b analysis',
        },
    },
    //DRD4ab-20    Poukaz na 20 vzoriek na analýzu DRD4a + DRD4b
    {
        id: 'DRD4ab-20',
        labels: {
            sk: 'Poukaz na 20 vzoriek na analýzu DRD4a + DRD4b',
            en: 'Voucher for 20 samples for DRD4a + DRD4b analysis',
        },
    },
    {
        id: 'DRD4ab-40',
        labels: {
            sk: 'Poukaz na 40 vzoriek na analýzu DRD4a + DRD4b',
            en: 'Voucher for 40 samples for DRD4a + DRD4b analysis',
        },
    },
]
export const voucherTypesOnline = [
    {
        id: '20E',
        labels: {
            sk: 'Poukaz na určenie pohlavia na 20 vzoriek, výsledky online',
            en: 'Voucher for determining gender for 20 samples, results online',
        },
    },
    {
        id: '50E',
        labels: {
            sk: 'Poukaz na určenie pohlavia na 50 vzoriek, výsledky online',
            en: 'Voucher for determining gender for 50 samples, results online',
        },
    },
    {
        id: '100E',
        labels: {
            sk: 'Poukaz na určenie pohlavia na 100 vzoriek, výsledky online',
            en: 'Voucher for determining gender for 100 samples, results online',
        },
    },
    //do the same for SD10E, SD20E, SD30E
    {
        id: 'SD10E',
        labels: {
            sk: 'Poukaz na určenie pohlavia + ochorení na 10 vzoriek, výsledky online',
            en: 'Voucher for determining gender + diseases for 10 samples, results online',
        },
    },
    {
        id: 'SD20E',
        labels: {
            sk: 'Poukaz na určenie pohlavia + ochorení na 20 vzoriek, výsledky online',
            en: 'Voucher for determining gender + diseases for 20 samples, results online',
        },
    },
    {
        id: 'SD30E',
        labels: {
            sk: 'Poukaz na určenie pohlavia + ochorení na 30 vzoriek, výsledky online',
            en: 'Voucher for determining gender + diseases for 30 samples, results online',
        },
    },
    //do the same for D10E, D20E, D30E
    {
        id: 'D10E',
        labels: {
            sk: 'Poukaz na detekciu ochorení na 10 vzoriek, výsledky online',
            en: 'Voucher for disease detection for 10 samples, results online',
        },
    },
    {
        id: 'D20E',
        labels: {
            sk: 'Poukaz na detekciu ochorení na 20 vzoriek, výsledky online',
            en: 'Voucher for disease detection for 20 samples, results online',
        },
    },
    {
        id: 'D30E',
        labels: {
            sk: 'Poukaz na detekciu ochorení na 30 vzoriek, výsledky online',
            en: 'Voucher for disease detection for 30 samples, results online',
        },
    },
]
